import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { Store } from '@ngrx/store';
import * as RootState from '@cde-fe-app/app/shared/state';
import * as AuthActions from '@cde-fe-app/app/shared/state/auth/auth.actions';

@Component({
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./callback.component.scss'],
})
export class CallbackComponent implements OnInit {
  private store = inject<Store<RootState.IState>>(Store<RootState.IState>);

  ngOnInit(): void {
    this.store.dispatch(new AuthActions.LoginCallback());
  }
}
